import Colors from '@/constants/Colors';
import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';
import { pxToVw } from '@/modules/styled/cssUnits';
import { Layout } from 'antd';
import styled from 'styled-components';

export const studentTopbarHeight = `max(50px, ${pxToVw(80)})`;

export const StyledStudentPageTopbar = styled(Layout.Header)`
  width: 100%;
  height: ${studentTopbarHeight};
  box-shadow: 0px 1px 4px ${Colors.boxShadowBlack};
  z-index: 2000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  padding: 0px ${pxToVw(30)};

  .left-items {
    display: flex;
    align-items: center;
    gap: ${pxToVw(20)};

    .logo {
      position: relative;
      aspect-ratio: calc(318 / 55);
      width: ${pxToVw(150)};
      display: flex;
      align-items: center;
      a {
        display: flex;
      }
    }

    .language-selector {
      margin-left: 10px;
      .option span {
        line-height: 14px;
      }
    }
  }

  .right-items {
    display: flex;
    align-items: center;
    gap: ${pxToVw(20)};

    .item {
      display: flex;
      .home-btn {
        display: block;
        line-height: 10px;
        .home-icon {
          font-size: 20px;
        }
      }
      .name-container {
        display: flex;
        align-items: center;
        gap: 10px;
        background: ${Colors.primary};
        border-radius: 100px;
        padding: 5px 25px;
        position: relative;

        .avatar {
          position: absolute;
          color: white;
          font-weight: bold;
          font-size: 26px;
          width: 45px;
          height: 45px;
          left: -25px;
          border-width: 3px;
        }
        .name {
          color: white;
          text-transform: uppercase;
          font-weight: bold;
          text-shadow: 0px 1px 0px ${Colors.textShadow};
        }
      }

      .topbar-scoreboard {
        .spin {
          color: white;
        }
      }
    }

    .logout {
      display: flex;
      align-items: center;
      gap: 5px;
      font-weight: normal;

      span {
        color: ${Colors.primary};
      }

      .icon {
        margin-bottom: 2px;
      }
    }
  }

  @media only screen and (max-width: ${MediaQueryBreakpoints.sm}) {
    padding: ${pxToVw(30)} ${pxToVw(30)};
    .logo {
      width: ${pxToVw(300)};
    }
  }
`;
